<div class="flex justify-center gap-2">
  <input
    #digitInput
    *ngFor="let digit of digits; let index = index"
    [value]="digit"
    [disabled]="disabled"
    type="text"
    inputmode="numeric"
    maxlength="1"
    [attr.autocomplete]="index === 0 ? 'one-time-code' : 'off'"
    [attr.name]="'mfa_digit_' + index"
    class="digit-input"
    [attr.aria-label]="'MFA digit ' + (index + 1)"
    (input)="handleInput($event, index)"
    (keydown)="handleKeydown($event, index)"
    (paste)="handlePaste($event, index)"
    (focus)="handleFocus($event)"
    (blur)="markTouched()"
  />
</div>
